import { ReactElement } from 'react';
import { Building07Icon } from 'icons';
import { Divider } from 'pages/NewOverview/components/Divider';
import { GraphTooltip } from 'pages/NewOverview/components/GraphTooltip';
import { TooltipContainer, TooltipRow } from './styles';
import { colorByHealthVariant, parseHealthVariantLabel } from '../../helpers';
import { colors } from '~/styles/colors';
import { useTranslation } from 'react-i18next';
import { HealthVariant } from '../UnitsInfo/types';
import { Circle } from 'pages/NewOverview/components/GraphTooltip/styles';

interface HealthTooltipGraphProps {
  date: string;
  percentage: number;
  units: number;
  variant: HealthVariant;
}

export function HealthTooltipGraph({
  date,
  units,
  percentage,
  variant,
}: Readonly<HealthTooltipGraphProps>): ReactElement {
  const { t } = useTranslation();
  const color = colorByHealthVariant(variant);

  return (
    <GraphTooltip
      date={date}
      type="month"
      style={{ height: 116 }}
    >
      <TooltipContainer>
        <TooltipRow>
          <Circle color={color} />
          <span>{parseHealthVariantLabel(variant)}</span>
          <span>
            {percentage}
            %
          </span>
        </TooltipRow>
        <Divider style={{ width: '100%' }} />
        <TooltipRow>
          <Building07Icon color={colors.icon['strong-900']} size="16" />
          <span>{t('unidades')}</span>
          <span>{units}</span>
        </TooltipRow>
      </TooltipContainer>
    </GraphTooltip>
  );
}
